import { FontModel } from '@leverege/ui-style-elements';
import StringUtil from '@leverege/string-util';
import Colorizers from "../../colorizer/Colorizers.js";
import Variantizers from "../../variantizer/Variantizers.js";
const VARIANT_CACHE = {};
function getBackground(background, object, cxt) {
  if (typeof background === 'string') {
    return background;
  }
  // If we want gradients, this should be a Backgroundizer 
  if (background && typeof background === 'object') {
    return Colorizers.getColor(background, object, cxt);
  }
  return null;
}
function getParentStyle(opts, bg, object, cxt) {
  const {
    align,
    justify
  } = opts;
  const style = {};
  if (typeof justify === 'string') {
    style.justify = justify;
  }
  if (typeof align === 'string') {
    style.align = align;
  }
  if (typeof bg === 'string') {
    style.background = bg;
  }
  return style;
}
function getStyle(opts, object, cxt) {
  const {
    color,
    font,
    wrap,
    spacing
  } = opts;
  const rtn = {};
  if (typeof color === 'string') {
    rtn.color = color;
  } else if (color && typeof color === 'object') {
    rtn.color = Colorizers.getColor(color, object, cxt);
  }
  if (font) {
    FontModel.toCss(font, rtn);
  }
  if (typeof wrap === 'boolean') {
    rtn.whiteSpace = wrap ? 'wrap' : 'nowrap';
  }
  if (typeof spacing === 'string') {
    rtn.paddingLeft = spacing;
  }
  return rtn;
}
function getVariant(opts, object, cxt, name = 'variant') {
  const {
    [name]: variant
  } = opts;
  const {
    usage
  } = cxt;
  if (variant) {
    const resolved = Variantizers.getVariant(variant, object, cxt) || '';
    if (resolved.length > 0) {
      let v = VARIANT_CACHE[resolved];
      if (v === undefined) {
        v = {};
        VARIANT_CACHE[resolved] = v;
      }
      let u = v[usage || 'default'];
      if (u === undefined) {
        if (usage) {
          const vs = resolved.split('|');
          const vSet = new Set();
          vs.forEach(v => {
            vSet.add(`${usage}${StringUtil.capitalize(v)}`);
            vSet.add(v);
          });
          u = [...vSet].join('|');
        } else {
          u = resolved;
        }
        v[usage || 'default'] = u;
      }
      return u;
    }
    return resolved;
  }
  return null;
}
function getLayout(opts, object, cxt, name = 'layout') {
  const {
    [name]: layout
  } = opts;
  if (!layout) {
    return null;
  }

  // No dynamic layout for now
  if (layout?.startsWith('flex:')) {
    return layout;
  }
  return `flex:${layout}`;
}

/**
 * Given an attribute type, this will create a detail type name
 * to be used by the models, editors, and detail factory.
 * This returns 'attr.detail.${type}'
 */
function getDetailTypeForType(type) {
  return `attr.detail.${type}`;
}
export default {
  getDetailTypeForType,
  getParentStyle,
  getStyle,
  getBackground,
  getVariant,
  getLayout
};